module.exports = __webpack_public_path__ + "static/media/backdrop.93fdd933.png";